import { Injectable, Injector } from '@angular/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { Subject, Observable } from 'rxjs';
import {SystemApp} from "../constans/SystemConfigurations";
import {ApiUrl} from "../shared/models/apiurl.models";
import {getFreshWsToken} from "../services/ws-token";

@Injectable({
    providedIn: 'root',
})
export class AdminWebsocketService {
    private socket$: WebSocketSubject<any> | null = null;
    private notification$ = new Subject<string>();
    private connecting = false;
    private reconnectTimeout: any = null;
    // A handshake that never delivered a message (403) forces one token
    // refresh on the next attempt - see services/ws-token.ts.
    private forceRefresh = false;
    private forcedRefreshUsed = false;

    constructor(private apiUrl: ApiUrl, private injector: Injector) {
    }
    connect(): void {
        if (this.socket$ || this.connecting) return;
        if (!this.apiUrl.getJWTTokenKey()) return;

        const force = this.forceRefresh && !this.forcedRefreshUsed;
        if (force) this.forcedRefreshUsed = true;
        this.connecting = true;
        getFreshWsToken(this.injector, force).then(token => {
            this.connecting = false;
            if (token && !this.socket$) this.open(token);
        });
    }

    private open(token: string): void {

        // POD1-6: the credential is offered as a WebSocket SUBPROTOCOL, never in
        // the URL. Query strings are written verbatim into nginx/proxy access
        // logs and browser history, so a token there leaks to anyone who can read
        // a log file. The browser WebSocket API cannot set headers, but it can
        // send subprotocols, and rxjs' webSocket() exposes that as `protocol`.
        // The backend (utils/ws_auth.py) reads `bearer, <jwt>` from
        // Sec-WebSocket-Protocol.
        //
        // The console.log that used to be here printed the working access
        // token into the browser console on every connect. Removed.
        let gotMessage = false;
        const socket$ = webSocket<any>({
            url: `${SystemApp.web_socket}admin/dashboard/`,
            protocol: ['bearer', token],
        });
        this.socket$ = socket$;

        // Previously there was no reconnect at all, and socket$ stayed set
        // after the socket died - so connect() returned early forever and the
        // online-users feed silently stopped until a full page reload.
        const dropped = (reason: string, err?: any) => {
            if (this.socket$ !== socket$) return;
            console.warn('Admin socket closed', reason, err || '');
            this.socket$ = null;
            if (!gotMessage) this.forceRefresh = true;
            if (!this.reconnectTimeout) {
                this.reconnectTimeout = setTimeout(() => {
                    this.reconnectTimeout = null;
                    this.connect();
                }, 5000);
            }
        };

        socket$.subscribe({
            next: (msg) => {
                gotMessage = true;
                this.forceRefresh = false;
                this.forcedRefreshUsed = false;
                if (msg.type == 'online_users') {
                    this.notification$.next(msg);
                }
            },
            error: (err) => dropped('error', err),
            complete: () => dropped('complete'),
        });
    }

    getNotifications(): Observable<string> {
        return this.notification$.asObservable();
    }

    // disconnect(): void {
    //     this.socket$?.complete();
    //     this.socket$ = null;
    // }
}
